export default __webpack_public_path__ + "static/media/G0002.bf332e59.png";